import React, {useState} from "react";
import {Tabs} from "antd";
import {TabsContainer} from "../../courier/courierDetail/courierDetailStyles";
import {MerchantSuccessPaymentsTab} from "./merchantSuccessPaymentsTab/MerchantSuccessPaymentsTab";
import {MerchantPendingInvoicePaymentsTab} from "./mechantPendingInvoicePaymentsTab/MerchantPendingInvoicePaymentsTab";
import {MerchantHasInvoicePaymentsTab} from "./merchantHasInvoicePaymentsTab/MerchantHasInvoicePaymentsTab";
import {MerchantCompletedPaymentsTab} from "./merchantCompletedPaymentsTab/MerchantCompletedPaymentsTab";
import {MerchantFailedPaymentsTab} from "./merchantFailedPaymentsTab/MerchantFailedPaymentsTab";
import {MerchantCanceledPaymentsTab} from "./merchantCanceledPaymentsTab/MerchantCanceledPaymentsTab";
import {MerchantPaymentSummaryPage} from "../summary/MerchantPaymentSummaryPage";
import {MerchantPastPeriodsTab} from "./merchantPastPeriodsTab/MerchantPastPeriodsTab";

export const MerchantCashOnDeliveryPage = () => {
    const [activeTab, setActiveTab] = useState("summary");

    return (
        <div style={{width: "100%", marginTop: "-50px"}}>
            <TabsContainer activeKey={activeTab} onChange={key => setActiveTab(key)}>
                <Tabs.TabPane tab="Özet" key="summary">
                    <MerchantPaymentSummaryPage isTabOpened={activeTab === "summary"} />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Geçmiş Dönemler" key="pastPeriodsTab">
                    <MerchantPastPeriodsTab isTabOpened={activeTab === "pastPeriodsTab"} />
                </Tabs.TabPane>
                {/*  <Tabs.TabPane tab="Tahsil Edilenler" key="successPaymentsTab">
                <MerchantSuccessPaymentsTab isTabOpened={activeTab === "successPaymentsTab"} />
            </Tabs.TabPane> */}
                {/*  <Tabs.TabPane tab="Fatura Bekleyen" key="pendingInvoicePaymentsTab">
                <MerchantPendingInvoicePaymentsTab
                    isTabOpened={activeTab === "pendingInvoicePaymentsTab"}
                />
            </Tabs.TabPane> */}
                {/* <Tabs.TabPane tab="Faturası Kesilmiş" key="hasInvoicePaymentsTab">
                <MerchantHasInvoicePaymentsTab
                    isTabOpened={activeTab === "hasInvoicePaymentsTab"}
                />
            </Tabs.TabPane>*/}
                {/* <Tabs.TabPane tab="Geri Ödemesi Alınan" key="completedPaymentsTab">
                <MerchantCompletedPaymentsTab isTabOpened={activeTab === "completedPaymentsTab"} />
            </Tabs.TabPane> */}
                {/* <Tabs.TabPane tab="İptal Edilen" key="canceledPaymentsTab">
                <MerchantCanceledPaymentsTab isTabOpened={activeTab === "canceledPaymentsTab"} />
            </Tabs.TabPane> */}
                {/*  <Tabs.TabPane tab="Bankadan Dönen" key="failedPaymentsTab">
                <MerchantFailedPaymentsTab isTabOpened={activeTab === "failedPaymentsTab"} />
            </Tabs.TabPane> */}
            </TabsContainer>
        </div>
    );
};
